(function () {
  const ACTIVE_SEARCH_CLASS = 'woods-boost-search-active';
  const EMPTY_SEARCH_CLASS = 'woods-boost-search-empty';
  const LOADING_SEARCH_CLASS = 'woods-boost-search-loading';
  const READY_SEARCH_CLASS = 'woods-boost-search-ready';
  const BOOST_MOBILE_SEARCH_OPEN_CLASS = 'woods-boost-mobile-search-open';
  const SEARCH_MODAL_SELECTOR = '#search-modal';
  const SEARCH_DIALOG_SELECTOR = `${SEARCH_MODAL_SELECTOR} dialog`;
  const SEARCH_TRIGGER_SELECTOR = '.search-modal__button';
  const NATIVE_SEARCH_CLOSE_SELECTOR = `${SEARCH_MODAL_SELECTOR} .predictive-search__close-modal-button`;
  const BOOST_SEARCH_WRAPPER_SELECTOR = [
    '#boost-sd__search-widget-init-wrapper',
    '.boost-sd__search-widget-init-wrapper',
    '.boost-sd__search-bar-wrapper--mobile',
  ].join(',');
  const BOOST_MOBILE_SEARCH_WRAPPER_SELECTOR = '.boost-sd__search-bar-wrapper--mobile';
  const BOOST_MOBILE_CLOSE_SELECTOR = `${BOOST_MOBILE_SEARCH_WRAPPER_SELECTOR} .boost-sd__button-text-x--close`;
  const BOOST_MOBILE_SEARCH_VISIBLE_CHILD_SELECTOR =
    '.boost-sd__search-bar, .boost-sd__search-bar-autocomplete, .boost-sd__search-bar-input, .boost-sd__instant-search-results, .boost-sd__instant-search-autocomplete';
  const BOOST_STALE_SEARCH_CLASSES = ['boost-sd__search-opening', 'boost-sd__g-no-scroll'];
  const BOOST_FALLBACK_VIEW_ALL_CLASS = 'woods-boost-view-all';
  const SEARCH_INPUT_SELECTOR = [
    `${SEARCH_MODAL_SELECTOR} .search-input`,
    '.boost-sd__search-input',
    '.boost-sd__input-search',
    '.boost-sd__search-box input[type="search"]',
    '.boost-sd__search-bar-input',
  ].join(',');
  const BOOST_RESULTS_ROOT_SELECTOR = [
    '#boost-sd__search-widget-init-wrapper .boost-sd__instant-search-autocomplete',
    '.boost-sd__search-widget-init-wrapper .boost-sd__instant-search-autocomplete',
    '.boost-sd__search-bar-wrapper--mobile .boost-sd__instant-search-autocomplete',
  ].join(',');
  const BOOST_PRODUCT_SELECTOR = '.boost-sd__suggestion-queries-item--product';
  const BOOST_PRODUCT_IMAGE_SELECTOR = '.boost-sd__suggestion-queries-item-img';
  const BOOST_PRODUCT_IMAGE_RENDER_WIDTH = 330;
  const BOOST_PRODUCT_IMAGE_SOURCE_WIDTH = BOOST_PRODUCT_IMAGE_RENDER_WIDTH * 2;
  const BOOST_READY_CONTENT_SELECTOR = [
    BOOST_PRODUCT_SELECTOR,
    '.boost-sd__suggestion-queries-item',
    '.boost-sd__instant-search-no-result',
    '.boost-sd__no-search-result',
  ].join(',');
  const BOOST_PRODUCT_LIST_SELECTOR = '.boost-sd__instant-search-product-list-items';
  const BOOST_PRODUCT_COLUMN_SELECTOR =
    '.boost-sd__instant-search-column--products, .boost-sd__instant-search-product-list';
  const BOOST_VIEW_ALL_SELECTOR = [
    '.boost-sd__view-all',
    '.boost-sd__view-all-link',
    '.boost-sd__view-all-button',
    '.boost-sd__button-view-all',
    '.boost-sd__instant-search-view-all',
    `.${BOOST_FALLBACK_VIEW_ALL_CLASS}`,
  ].join(',');
  const BOOST_POPULAR_SUGGESTION_LINK_SELECTOR =
    '.boost-sd__suggestion-queries-group:has(.boost-sd__suggestion-queries-header--suggestions) .boost-sd__suggestion-queries-link';
  const BOOST_SEARCH_SURFACE_SELECTOR = [
    BOOST_SEARCH_WRAPPER_SELECTOR,
    BOOST_RESULTS_ROOT_SELECTOR,
    '.boost-sd__instant-search-results',
    BOOST_PRODUCT_COLUMN_SELECTOR,
    BOOST_PRODUCT_LIST_SELECTOR,
    BOOST_VIEW_ALL_SELECTOR,
  ].join(',');
  const SEARCH_SHELL_SURFACE_SELECTOR = [
    `${SEARCH_MODAL_SELECTOR} .search-modal__content`,
    `${SEARCH_MODAL_SELECTOR} .predictive-search-form__header`,
    `${SEARCH_MODAL_SELECTOR} .predictive-search-form__input-wrapper`,
    `${SEARCH_MODAL_SELECTOR} .predictive-search-form__content-wrapper`,
  ].join(',');
  const SEARCH_INTERACTIVE_CLICK_SELECTOR = [
    'a[href]',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'summary',
    '[role="button"]',
  ].join(',');
  const SEARCH_OBSERVER_ROOT_SELECTOR = [
    SEARCH_MODAL_SELECTOR,
    '#boost-sd__search-widget-init-wrapper',
    '.boost-sd__search-widget-init-wrapper',
    '.boost-sd__search-bar-wrapper--mobile',
  ].join(',');
  let boostSearchUpdateScheduled = false;
  let searchActivationChecks = [];
  let boostSearchLoadingFallback = 0;
  let nativeSearchCloseRequested = false;
  let searchInputVersion = 0;
  let boostContentVersion = 0;
  let latestSearchTerm = '';

  const setBoostSearchTopOffset = () => {
    const announcementBar = document.querySelector('#header-group .announcement-bar');
    const announcementBottom = announcementBar ? announcementBar.getBoundingClientRect().bottom : 0;
    const topOffset = Math.max(0, Math.round(announcementBottom));
    const nextTopOffset = `${topOffset}px`;

    if (document.documentElement.style.getPropertyValue('--woods-boost-search-top') !== nextTopOffset) {
      document.documentElement.style.setProperty('--woods-boost-search-top', nextTopOffset);
    }
  };

  const getNativeSearchResultCount = () => {
    const resultText = document
      .querySelector(`${SEARCH_MODAL_SELECTOR} .predictive-search-form__content`)
      ?.textContent?.trim();
    const resultCount = resultText?.match(/(\d+)\s+search results found/i)?.[1];

    return resultCount || '';
  };

  const normalizeViewAllText = (label) => {
    const currentText = label.textContent.trim();
    const nextText = currentText.replace(/^view all/i, 'Shop all');

    if (nextText && nextText !== currentText) {
      label.textContent = nextText;
    }
  };

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const getBoostProductImageSource = (value) => {
    if (!value || /^(data|blob):/i.test(value)) return null;

    try {
      const imageUrl = new URL(value, window.location.href);
      const isShopifyImage =
        imageUrl.hostname === 'cdn.shopify.com' ||
        imageUrl.pathname.startsWith('/cdn/shop/') ||
        imageUrl.pathname.startsWith('/s/files/');

      if (!isShopifyImage) return null;

      const currentWidth = Number.parseInt(imageUrl.searchParams.get('width') || '', 10);
      const sourceWidth =
        Number.isFinite(currentWidth) && currentWidth >= BOOST_PRODUCT_IMAGE_SOURCE_WIDTH
          ? currentWidth
          : BOOST_PRODUCT_IMAGE_SOURCE_WIDTH;

      if (currentWidth !== sourceWidth) {
        imageUrl.searchParams.set('width', String(sourceWidth));
      }

      return {
        url: imageUrl.toString(),
        width: sourceWidth,
      };
    } catch (error) {
      return null;
    }
  };

  const normalizeBoostProductImages = () => {
    const nextSizes = `${BOOST_PRODUCT_IMAGE_RENDER_WIDTH}px`;

    document.querySelectorAll(BOOST_PRODUCT_IMAGE_SELECTOR).forEach((image) => {
      if (!(image instanceof HTMLImageElement)) return;

      const imageSource = getBoostProductImageSource(
        image.getAttribute('src') || image.currentSrc || image.src
      );

      if (!imageSource) return;

      const nextSrcset = `${imageSource.url} ${imageSource.width}w`;
      const nextWidth = String(imageSource.width);
      const isCurrent =
        image.dataset.woodsBoostImageWidth === nextWidth &&
        image.getAttribute('src') === imageSource.url &&
        image.getAttribute('srcset') === nextSrcset &&
        image.getAttribute('sizes') === nextSizes;

      if (isCurrent) return;

      image.setAttribute('src', imageSource.url);
      image.setAttribute('srcset', nextSrcset);
      image.setAttribute('sizes', nextSizes);
      image.dataset.woodsBoostImageWidth = nextWidth;
    });
  };

  const normalizeBoostSuggestionHighlights = () => {
    const searchTerm = getSearchTerm();
    const escapedSearchTerm = searchTerm ? escapeRegExp(searchTerm) : '';
    const searchPattern = escapedSearchTerm ? new RegExp(escapedSearchTerm, 'gi') : null;
    const normalizedSearchTerm = searchTerm.toLowerCase();

    document.querySelectorAll(BOOST_POPULAR_SUGGESTION_LINK_SELECTOR).forEach((link) => {
      const textElement = link.querySelector('span[aria-hidden="true"]') || link;

      if (!(textElement instanceof HTMLElement)) return;

      const suggestionText = textElement.textContent.trim().replace(/\s+/g, ' ');
      const isCurrent =
        textElement.dataset.woodsBoostSuggestionHighlightTerm === normalizedSearchTerm &&
        textElement.dataset.woodsBoostSuggestionHighlightText === suggestionText;

      if (isCurrent) return;

      if (searchPattern) {
        searchPattern.lastIndex = 0;
      }

      if (!suggestionText || !searchPattern?.test(suggestionText)) {
        if (textElement.dataset.woodsBoostSuggestionHighlightTerm) {
          textElement.textContent = suggestionText;
          delete textElement.dataset.woodsBoostSuggestionHighlightTerm;
          delete textElement.dataset.woodsBoostSuggestionHighlightText;
        }

        return;
      }

      const highlightedSuggestion = document.createDocumentFragment();
      const lowerSuggestionText = suggestionText.toLowerCase();
      let lastIndex = 0;

      if (normalizedSearchTerm && lowerSuggestionText.startsWith(normalizedSearchTerm)) {
        const prefix = suggestionText.slice(0, searchTerm.length);
        const suffix = suggestionText.slice(searchTerm.length);

        highlightedSuggestion.append(document.createTextNode(prefix));

        if (suffix.trim()) {
          const highlight = document.createElement('strong');
          highlight.className = 'woods-boost-suggestion-highlight';
          highlight.textContent = suffix;
          highlightedSuggestion.append(highlight);
        } else {
          highlightedSuggestion.append(document.createTextNode(suffix));
        }

        textElement.textContent = '';
        textElement.append(highlightedSuggestion);
        textElement.dataset.woodsBoostSuggestionHighlightTerm = normalizedSearchTerm;
        textElement.dataset.woodsBoostSuggestionHighlightText = suggestionText;

        return;
      }

      searchPattern.lastIndex = 0;
      suggestionText.replace(searchPattern, (match, offset) => {
        if (offset > lastIndex) {
          highlightedSuggestion.append(document.createTextNode(suggestionText.slice(lastIndex, offset)));
        }

        const highlight = document.createElement('strong');
        highlight.className = 'woods-boost-suggestion-highlight';
        highlight.textContent = match;
        highlightedSuggestion.append(highlight);
        lastIndex = offset + match.length;

        return match;
      });

      if (lastIndex < suggestionText.length) {
        highlightedSuggestion.append(document.createTextNode(suggestionText.slice(lastIndex)));
      }

      textElement.textContent = '';
      textElement.append(highlightedSuggestion);
      textElement.dataset.woodsBoostSuggestionHighlightTerm = normalizedSearchTerm;
      textElement.dataset.woodsBoostSuggestionHighlightText = suggestionText;
    });
  };

  const normalizeBoostSearchCta = () => {
    document
      .querySelectorAll(
        '.boost-sd__view-all-text, .boost-sd__view-all-button, .boost-sd__button-view-all, .boost-sd__instant-search-view-all'
      )
      .forEach(normalizeViewAllText);

    document.querySelectorAll('.boost-sd__view-all-link').forEach((link) => {
      if (!link.querySelector('.boost-sd__view-all-text')) {
        normalizeViewAllText(link);
      }
    });

    document.querySelectorAll(`${SEARCH_MODAL_SELECTOR} .predictive-search__search-button`).forEach((button) => {
      const resultCount = getNativeSearchResultCount();
      const nextText = resultCount ? `Shop all ${resultCount} products` : 'Shop all products';

      if (button.textContent !== nextText) {
        button.textContent = nextText;
      }
    });
  };

  const getSearchInputs = () => Array.from(document.querySelectorAll(SEARCH_INPUT_SELECTOR));

  const getPrimarySearchInput = () => {
    const searchInput = document.querySelector(`${SEARCH_MODAL_SELECTOR} .search-input`);

    return searchInput instanceof HTMLInputElement ? searchInput : null;
  };

  const getInputSearchTerm = (input) => (input instanceof HTMLInputElement ? input.value.trim() : '');

  const getFocusedSearchInput = () =>
    document.activeElement instanceof HTMLInputElement && document.activeElement.matches(SEARCH_INPUT_SELECTOR)
      ? document.activeElement
      : null;

  const getSearchTerm = () => {
    const focusedSearchInput = getFocusedSearchInput();
    const focusedSearchTerm = getInputSearchTerm(focusedSearchInput);

    if (focusedSearchTerm) return focusedSearchTerm;

    const visibleSearchInput = getSearchInputs().find(
      (input) => input instanceof HTMLInputElement && isVisibleElement(input) && getInputSearchTerm(input)
    );

    if (visibleSearchInput instanceof HTMLInputElement) return getInputSearchTerm(visibleSearchInput);

    const primarySearchInput = getPrimarySearchInput();
    const primarySearchTerm = getInputSearchTerm(primarySearchInput);

    if (primarySearchTerm) return primarySearchTerm;

    const activeInput = getSearchInputs().find(
      (input) => input instanceof HTMLInputElement && getInputSearchTerm(input).length > 0
    );

    return getInputSearchTerm(activeInput);
  };

  const hasSearchTerm = () => getSearchTerm().length > 0;

  const hasBoostSearchContent = () =>
    Array.from(document.querySelectorAll(BOOST_RESULTS_ROOT_SELECTOR)).some((resultsRoot) =>
      resultsRoot.querySelector(BOOST_READY_CONTENT_SELECTOR)
    );

  const syncSearchTermSnapshot = () => {
    const searchTerm = getSearchTerm();

    if (searchTerm !== latestSearchTerm) {
      latestSearchTerm = searchTerm;
      searchInputVersion += 1;
    }

    return searchTerm;
  };

  const boostContentMatchesSearchTerm = (searchTerm) => {
    const normalizedSearchTerm = searchTerm.trim().toLowerCase();

    if (!normalizedSearchTerm) return false;

    return Array.from(document.querySelectorAll(BOOST_RESULTS_ROOT_SELECTOR)).some((resultsRoot) => {
      const resultText = resultsRoot.textContent?.trim().toLowerCase() || '';

      if (resultText.includes(normalizedSearchTerm)) return true;

      return Array.from(resultsRoot.querySelectorAll('a[href]')).some((link) => {
        try {
          const linkUrl = new URL(link.getAttribute('href') || '', window.location.href);
          const linkQuery = linkUrl.searchParams.get('q')?.toLowerCase() || '';

          return linkQuery.includes(normalizedSearchTerm);
        } catch (error) {
          return false;
        }
      });
    });
  };

  const hasBoostSearchContentForCurrentTerm = () => {
    const searchTerm = getSearchTerm();

    if (!searchTerm || !hasBoostSearchContent()) return false;
    if (boostContentMatchesSearchTerm(searchTerm)) return true;

    return boostContentVersion >= searchInputVersion && !document.body.classList.contains(LOADING_SEARCH_CLASS);
  };

  const clearBoostSearchInputs = () => {
    getSearchInputs().forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.value = '';
      }
    });

    latestSearchTerm = '';
  };

  const buildSearchResultsUrl = (searchTerm) => {
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', searchTerm);

    return url.toString();
  };

  const getViewAllElement = (node) => {
    if (!(node instanceof Element)) return null;

    return node.matches('.boost-sd__view-all') ? node : node.closest('.boost-sd__view-all');
  };

  const getViewAllTarget = (resultsRoot) => {
    const productList = resultsRoot.querySelector(BOOST_PRODUCT_LIST_SELECTOR);
    const productColumn = productList?.closest(BOOST_PRODUCT_COLUMN_SELECTOR);

    return (
      productColumn ||
      productList?.parentElement ||
      resultsRoot.querySelector(BOOST_PRODUCT_COLUMN_SELECTOR) ||
      resultsRoot
    );
  };

  const moveViewAllAfterProducts = (resultsRoot, viewAll) => {
    const target = getViewAllTarget(resultsRoot);

    if (target && viewAll.parentElement !== target) {
      target.append(viewAll);
    }
  };

  const clearSearchActivationChecks = () => {
    searchActivationChecks.forEach((check) => window.clearTimeout(check));
    searchActivationChecks = [];
  };

  const openNativeSearchDialog = () => {
    const searchModal = document.querySelector(SEARCH_MODAL_SELECTOR);

    if (searchModal && typeof searchModal.showDialog === 'function') {
      searchModal.showDialog();
      return true;
    }

    return false;
  };

  const validateSearchActivation = () => {
    if (isSearchUiOpen()) return;

    if (!hasSearchTerm() && openNativeSearchDialog()) {
      searchActivationChecks.push(
        window.setTimeout(() => {
          if (!isSearchUiOpen()) {
            clearSearchActive();
          }
        }, 450)
      );
      return;
    }

    clearSearchActive();
  };

  const getFallbackViewAllText = (productItems) => {
    const resultCount = String(productItems.length || '');

    return resultCount ? `Shop all ${resultCount} products` : 'Shop all products';
  };

  const parsePriceValue = (value) => {
    const parsedValue = Number.parseFloat(value.replace(/[^0-9.,-]/g, '').replace(/,/g, ''));

    return Number.isFinite(parsedValue) ? parsedValue : null;
  };

  const formatSaleAmount = (amount, referenceText) => {
    const currencySymbol = referenceText.match(/[^\d\s.,-]+/)?.[0] || '£';
    const hasPence = /[.,]\d{2}\b/.test(referenceText) || !Number.isInteger(amount);
    const formattedAmount = amount.toLocaleString('en-GB', {
      minimumFractionDigits: hasPence ? 2 : 0,
      maximumFractionDigits: 2,
    });

    return `${currencySymbol}${formattedAmount}`;
  };

  const buildSalePricePart = (className, text, label) => {
    const part = document.createElement('span');
    const value = document.createElement('span');

    part.className = className;
    value.textContent = text;

    if (label) {
      part.append(label, ' ');
    }

    part.append(value);

    return part;
  };

  const normalizeBoostSaleBadge = (price, saleText, compareText, saleValue, compareValue) => {
    if (saleValue === null || compareValue === null || compareValue <= saleValue) return;

    const productItem = price.closest(BOOST_PRODUCT_SELECTOR);
    const saleBadge = productItem?.querySelector('.boost-sd__suggestion-queries-item-badge--sale');

    if (!(saleBadge instanceof HTMLElement) || saleBadge.dataset.woodsBoostSaleBadgeNormalized === 'true') return;

    const saleAmount = formatSaleAmount(compareValue - saleValue, compareText || saleText);
    const badgeLabel = document.createElement('span');
    const badgeAmount = document.createElement('span');

    badgeLabel.className = 'woods-boost-sale-badge-label';
    badgeLabel.textContent = 'Save';
    badgeAmount.className = 'woods-boost-sale-badge-amount';
    badgeAmount.textContent = saleAmount;

    saleBadge.textContent = '';
    saleBadge.dataset.woodsBoostSaleBadgeNormalized = 'true';
    saleBadge.append(badgeLabel, badgeAmount);
  };

  const normalizeBoostSalePrices = () => {
    document.querySelectorAll('.boost-sd__suggestion-queries-item-amount--sale').forEach((price) => {
      if (!(price instanceof HTMLElement) || price.dataset.woodsBoostPriceNormalized === 'true') return;

      const salePrice = price.querySelector('.boost-sd__format-currency--price-sale, .boost-sd__format-currency--sale');
      const comparePrice = price.querySelector(
        '.boost-sd__format-currency--price-compare, .boost-sd__format-currency--compare'
      );
      const saleText = salePrice?.textContent?.trim();
      const compareText = comparePrice?.textContent?.trim();

      if (!saleText || !compareText) return;

      const saleValue = parsePriceValue(saleText);
      const compareValue = parsePriceValue(compareText);
      const percentSaved =
        saleValue !== null && compareValue !== null && compareValue > saleValue
          ? Math.round(((compareValue - saleValue) / compareValue) * 100)
          : null;

      normalizeBoostSaleBadge(price, saleText, compareText, saleValue, compareValue);

      price.textContent = '';
      price.dataset.woodsBoostPriceNormalized = 'true';
      price.setAttribute(
        'aria-label',
        `Was ${compareText}${percentSaved ? ` ${percentSaved}% off` : ''}. Now ${saleText}`
      );
      price.append(
        buildSalePricePart('woods-boost-price-was', compareText, 'Was'),
        ...(percentSaved ? [buildSalePricePart('woods-boost-price-saving', `-${percentSaved}%`)] : []),
        buildSalePricePart('woods-boost-price-now', saleText, 'Now')
      );
    });
  };

  const syncBoostFallbackViewAll = () => {
    const searchTerm = getSearchTerm();

    document.querySelectorAll(`.${BOOST_FALLBACK_VIEW_ALL_CLASS}`).forEach((viewAll) => {
      const viewAllLink = viewAll.querySelector('.boost-sd__view-all-link');

      if (!searchTerm) {
        viewAll.remove();
      } else if (viewAllLink instanceof HTMLAnchorElement) {
        viewAllLink.href = buildSearchResultsUrl(searchTerm);
      }
    });

    if (!searchTerm) return;

    document.querySelectorAll(BOOST_RESULTS_ROOT_SELECTOR).forEach((resultsRoot) => {
      const productItems = resultsRoot.querySelectorAll(BOOST_PRODUCT_SELECTOR);
      const existingViewAll = getViewAllElement(resultsRoot.querySelector(BOOST_VIEW_ALL_SELECTOR));

      if (existingViewAll) {
        moveViewAllAfterProducts(resultsRoot, existingViewAll);
      }

      if (!productItems.length || existingViewAll) return;

      const viewAll = document.createElement('div');
      const viewAllLink = document.createElement('a');
      const viewAllText = document.createElement('span');

      viewAll.className = `boost-sd__view-all ${BOOST_FALLBACK_VIEW_ALL_CLASS}`;
      viewAllLink.className = 'boost-sd__view-all-link';
      viewAllLink.href = buildSearchResultsUrl(searchTerm);
      viewAllText.className = 'boost-sd__view-all-text';
      viewAllText.textContent = getFallbackViewAllText(productItems);

      viewAllLink.append(viewAllText);
      viewAll.append(viewAllLink);
      moveViewAllAfterProducts(resultsRoot, viewAll);
    });
  };

  const setSearchActive = () => {
    document.body.classList.add(ACTIVE_SEARCH_CLASS);
    syncBoostMobileSearchOpenState();
    updateSearchEmptyState();
    syncBoostSearchLoadState();

    clearSearchActivationChecks();
    searchActivationChecks = [700, 1200].map((delay) => window.setTimeout(validateSearchActivation, delay));
  };

  const clearSearchActive = () => {
    clearSearchActivationChecks();
    clearBoostSearchLoadState();
    document.body.classList.remove(
      ACTIVE_SEARCH_CLASS,
      EMPTY_SEARCH_CLASS,
      BOOST_MOBILE_SEARCH_OPEN_CLASS,
      ...BOOST_STALE_SEARCH_CLASSES
    );
    clearStaleSearchScrollLock();
    clearBoostSearchInputs();
    document.querySelectorAll(`.${BOOST_FALLBACK_VIEW_ALL_CLASS}`).forEach((viewAll) => viewAll.remove());
  };

  const isSearchDialogOpen = () => {
    const dialog = document.querySelector(SEARCH_DIALOG_SELECTOR);

    return Boolean(dialog instanceof HTMLDialogElement && dialog.open);
  };

  const isVisibleElement = (element) => {
    if (!(element instanceof HTMLElement)) return false;

    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0
    );
  };

  const isSearchInputFocused = () =>
    document.activeElement instanceof Element &&
    document.activeElement.matches(SEARCH_INPUT_SELECTOR) &&
    Boolean(document.activeElement.closest(SEARCH_OBSERVER_ROOT_SELECTOR));

  const isBoostMobileSearchOpen = () =>
    Array.from(document.querySelectorAll(BOOST_MOBILE_SEARCH_WRAPPER_SELECTOR)).some((wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return false;

      const styles = window.getComputedStyle(wrapper);

      if (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0') return false;
      if (isVisibleElement(wrapper)) return true;

      return Array.from(wrapper.querySelectorAll(BOOST_MOBILE_SEARCH_VISIBLE_CHILD_SELECTOR)).some(isVisibleElement);
    });

  const isBoostSearchWrapperOpen = () =>
    Array.from(document.querySelectorAll(BOOST_SEARCH_WRAPPER_SELECTOR)).some((wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return false;

      const styles = window.getComputedStyle(wrapper);

      if (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0') return false;
      if (isVisibleElement(wrapper)) return true;

      return Array.from(wrapper.querySelectorAll(BOOST_MOBILE_SEARCH_VISIBLE_CHILD_SELECTOR)).some(isVisibleElement);
    });

  const isSearchUiOpen = () => isSearchDialogOpen() || isBoostSearchWrapperOpen() || isSearchInputFocused();

  const syncBoostMobileSearchOpenState = () => {
    const isMobileSearchOpen = isBoostMobileSearchOpen();
    const wasMobileSearchOpen = document.body.classList.contains(BOOST_MOBILE_SEARCH_OPEN_CLASS);

    if (wasMobileSearchOpen !== isMobileSearchOpen) {
      document.body.classList.toggle(BOOST_MOBILE_SEARCH_OPEN_CLASS, isMobileSearchOpen);
    }

    return isMobileSearchOpen;
  };

  const syncSearchActiveState = () => {
    const isSearchOpen = isSearchUiOpen();

    syncBoostMobileSearchOpenState();

    if (isSearchOpen) {
      document.body.classList.add(ACTIVE_SEARCH_CLASS);
    } else if (document.body.classList.contains(ACTIVE_SEARCH_CLASS)) {
      clearSearchActive();
    }

    return isSearchOpen;
  };

  const clearStaleSearchScrollLock = () => {
    if (
      document.documentElement.hasAttribute('scroll-lock') ||
      isSearchDialogOpen() ||
      document.querySelector('dialog[open]') ||
      document.body.style.position !== 'fixed'
    ) {
      return;
    }

    const lockedTop = parseInt(document.body.style.top || '0', 10);
    const scrollY = Number.isFinite(lockedTop) ? Math.abs(lockedTop) : window.scrollY;

    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';

    if (scrollY > 0) {
      window.scrollTo(0, scrollY);
    }
  };

  const releaseNativeDialogScrollLock = () => {
    const lockedTop = parseInt(document.body.style.top || '0', 10);
    const scrollY = Number.isFinite(lockedTop) ? Math.abs(lockedTop) : window.scrollY;

    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.documentElement.removeAttribute('scroll-lock');

    if (scrollY > 0) {
      window.scrollTo(0, scrollY);
    }
  };

  const closeNativeDialogForBoostSearch = () => {
    if (!isBoostSearchWrapperOpen() || !hasBoostSearchContentForCurrentTerm()) return;

    const dialog = document.querySelector(SEARCH_DIALOG_SELECTOR);

    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    dialog.close();
    releaseNativeDialogScrollLock();
  };

  const requestNativeSearchClose = () => {
    nativeSearchCloseRequested = true;
  };

  const handleNativeSearchDialogClose = () => {
    const shouldKeepBoostSearchOpen = !nativeSearchCloseRequested && isBoostSearchWrapperOpen();

    nativeSearchCloseRequested = false;

    if (!shouldKeepBoostSearchOpen) {
      clearSearchActive();
      return;
    }

    releaseNativeDialogScrollLock();
    document.body.classList.add(ACTIVE_SEARCH_CLASS);
    syncBoostMobileSearchOpenState();
    updateSearchEmptyState();
    syncBoostSearchLoadState();
    scheduleBoostSearchUiUpdate();
  };

  const restoreBoostSearchSurface = () => {
    if (!hasSearchTerm() || !hasBoostSearchContentForCurrentTerm()) return;

    clearSearchActivationChecks();
    window.clearTimeout(boostSearchLoadingFallback);
    document.body.classList.add(ACTIVE_SEARCH_CLASS, READY_SEARCH_CLASS, 'boost-sd__search-opening');
    document.body.classList.remove(EMPTY_SEARCH_CLASS, LOADING_SEARCH_CLASS);
    syncBoostMobileSearchOpenState();
    scheduleBoostSearchUiUpdate();
  };

  const keepBoostSearchSurfaceOpen = (event) => {
    if (!(event.target instanceof Element)) return;
    const isBoostSurfaceClick = Boolean(event.target.closest(BOOST_SEARCH_SURFACE_SELECTOR));
    const isSearchShellClick =
      document.body.classList.contains(ACTIVE_SEARCH_CLASS) &&
      Boolean(event.target.closest(SEARCH_SHELL_SURFACE_SELECTOR));

    if (!isBoostSurfaceClick && !isSearchShellClick) return;
    if (event.target.closest(SEARCH_INTERACTIVE_CLICK_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    window.setTimeout(restoreBoostSearchSurface, 0);
    window.setTimeout(restoreBoostSearchSurface, 80);
  };

  const updateSearchEmptyState = () => {
    const isSearchActive = document.body.classList.contains(ACTIVE_SEARCH_CLASS) || isSearchUiOpen();
    const isEmpty = isSearchActive && !hasSearchTerm();
    const wasEmpty = document.body.classList.contains(EMPTY_SEARCH_CLASS);

    if (wasEmpty !== isEmpty) {
      document.body.classList.toggle(EMPTY_SEARCH_CLASS, isEmpty);
    }

    if (isEmpty || !isSearchActive) {
      clearBoostSearchLoadState();
    }
  };

  const clearBoostSearchLoadState = () => {
    window.clearTimeout(boostSearchLoadingFallback);

    if (
      document.body.classList.contains(LOADING_SEARCH_CLASS) ||
      document.body.classList.contains(READY_SEARCH_CLASS)
    ) {
      document.body.classList.remove(LOADING_SEARCH_CLASS, READY_SEARCH_CLASS);
    }
  };

  const setBoostSearchLoading = () => {
    window.clearTimeout(boostSearchLoadingFallback);
    document.body.classList.add(LOADING_SEARCH_CLASS);
    document.body.classList.remove(READY_SEARCH_CLASS);

    boostSearchLoadingFallback = window.setTimeout(() => {
      document.body.classList.remove(LOADING_SEARCH_CLASS);
    }, 1400);
  };

  const syncBoostSearchLoadState = () => {
    const isSearchActive = document.body.classList.contains(ACTIVE_SEARCH_CLASS) || isSearchUiOpen();

    if (!isSearchActive || !hasSearchTerm()) {
      clearBoostSearchLoadState();
      return false;
    }

    if (hasBoostSearchContentForCurrentTerm()) {
      window.clearTimeout(boostSearchLoadingFallback);
      document.body.classList.remove(LOADING_SEARCH_CLASS);
      document.body.classList.add(READY_SEARCH_CLASS);
      return true;
    }

    if (
      !document.body.classList.contains(READY_SEARCH_CLASS) &&
      !document.body.classList.contains(LOADING_SEARCH_CLASS)
    ) {
      setBoostSearchLoading();
    }

    return false;
  };

  const initBoostSearchState = () => {
    const searchModal = document.querySelector(SEARCH_MODAL_SELECTOR);

    ['pointerdown', 'mousedown', 'click'].forEach((eventName) => {
      window.addEventListener(eventName, keepBoostSearchSurfaceOpen, true);
    });

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        if (event.target.closest(NATIVE_SEARCH_CLOSE_SELECTOR)) {
          requestNativeSearchClose();
          clearSearchActive();
          return;
        }

        if (event.target.closest(BOOST_MOBILE_CLOSE_SELECTOR)) {
          window.setTimeout(clearSearchActive, 0);
          return;
        }

        if (event.target.closest(SEARCH_TRIGGER_SELECTOR)) {
          setSearchActive();
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && document.body.classList.contains(ACTIVE_SEARCH_CLASS)) {
          requestNativeSearchClose();
        }

        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
          setSearchActive();
        }
      },
      true
    );

    document.addEventListener('input', (event) => {
      if (event.target instanceof Element && event.target.matches(SEARCH_INPUT_SELECTOR)) {
        const searchTerm = syncSearchTermSnapshot();

        if (searchTerm) {
          setBoostSearchLoading();
        }

        updateSearchEmptyState();
        scheduleBoostSearchUiUpdate();
      }
    });

    searchModal?.addEventListener('dialog:open', setSearchActive);
    searchModal?.addEventListener('dialog:close', handleNativeSearchDialogClose);

    updateSearchEmptyState();
  };

  const updateBoostSearchUi = () => {
    setBoostSearchTopOffset();
    syncSearchActiveState();
    normalizeBoostSearchCta();
    updateSearchEmptyState();
    const isBoostReady = syncBoostSearchLoadState();
    normalizeBoostSalePrices();
    normalizeBoostProductImages();
    normalizeBoostSuggestionHighlights();

    if (isBoostReady) {
      closeNativeDialogForBoostSearch();
    }

    if (isBoostReady || !document.body.classList.contains(LOADING_SEARCH_CLASS)) {
      syncBoostFallbackViewAll();
    }
  };

  const scheduleBoostSearchUiUpdate = () => {
    if (boostSearchUpdateScheduled) return;

    boostSearchUpdateScheduled = true;

    window.requestAnimationFrame(() => {
      boostSearchUpdateScheduled = false;
      updateBoostSearchUi();
    });
  };

  const nodeContainsSearchUi = (node) => {
    if (!(node instanceof Element)) return false;

    return Boolean(
      node.matches(SEARCH_OBSERVER_ROOT_SELECTOR) || node.querySelector(SEARCH_OBSERVER_ROOT_SELECTOR)
    );
  };

  const mutationTouchesSearchUi = (mutation) => {
    const target = mutation.target;
    const targetElement =
      target instanceof Element ? target : target.parentElement instanceof Element ? target.parentElement : null;

    if (targetElement?.closest(SEARCH_OBSERVER_ROOT_SELECTOR)) return true;

    return [...mutation.addedNodes, ...mutation.removedNodes].some(nodeContainsSearchUi);
  };

  const nodeContainsBoostSearchUi = (node) => {
    if (!(node instanceof Element)) return false;

    return Boolean(node.matches(BOOST_SEARCH_WRAPPER_SELECTOR) || node.querySelector(BOOST_SEARCH_WRAPPER_SELECTOR));
  };

  const mutationTouchesBoostSearchUi = (mutation) => {
    const target = mutation.target;
    const targetElement =
      target instanceof Element ? target : target.parentElement instanceof Element ? target.parentElement : null;

    if (targetElement?.closest(BOOST_SEARCH_WRAPPER_SELECTOR)) return true;

    return [...mutation.addedNodes, ...mutation.removedNodes].some(nodeContainsBoostSearchUi);
  };

  const initBoostSearchCtaObserver = () => {
    initBoostSearchState();
    updateBoostSearchUi();

    window.addEventListener('resize', scheduleBoostSearchUiUpdate);

    const observer = new MutationObserver((mutations) => {
      const touchesBoostSearchUi = mutations.some(mutationTouchesBoostSearchUi);
      const touchesSearchUi = touchesBoostSearchUi || mutations.some(mutationTouchesSearchUi);
      if (touchesBoostSearchUi) {
        boostContentVersion = Math.max(boostContentVersion, searchInputVersion);
      }

      // Body classes are also managed by Boost's cart and app bootstrap code.
      // Do not turn unrelated body mutations into a search update feedback loop.
      if (!touchesSearchUi) return;

      scheduleBoostSearchUiUpdate();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open', 'style', 'aria-expanded'],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoostSearchCtaObserver, { once: true });
  } else {
    initBoostSearchCtaObserver();
  }
})();
